<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { mapGetters } from 'vuex'
import {
  warehouseMethods,
  reportsMethods,
  groupingMethods,
} from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import ProductsTable from '@components/retina/products/productsTable'
import MultiSelectWarehouse from '@components/retina/MultiSelectWarehouse'

export default {
  name: 'Reports',
  page: {
    title: 'Reportes',
    meta: [
      {
        name: 'Reportes',
        content: 'Reportes',
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    MultiSelectWarehouse,
    ProductsTable,
  },
  data() {
    return {
      title: '<i class="fas fa-clipboard-list"></i> Reportes por Bodegas',
      items: [
        {
          text: 'Reportes',
        },
        {
          text: 'Lista de Reportes',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'warehouses', label: 'Grupos de Bodegas' },
        // { key: 'consolidated', label: 'Consolidado' },
        { key: 'actions', label: '', class: 'w-50' },
      ],
      tableHeadersUbications: [
        { key: 'nit', label: 'NIT', class: 'd-none d-lg-table-cell' },
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: '', class: 'w-50' },
      ],
      tableHeadersNovelty: [
        { key: 'name', label: 'Nombre' },
        { key: 'reference', label: 'Referencia' },
        { key: 'id_ext1', label: 'Extensión' },
        { key: 'novelty', label: 'Novedad' },
      ],
      tableHeadersConsolidated: [
        { key: 'name', label: 'Nombre' },
        { key: 'reference', label: 'Referencia' },
        { key: 'id_ext1', label: 'Extensión' },
        { key: 'quantity', label: 'Existencias' },
        { key: 'consolidated', label: 'Consolidados' },
      ],
      modalConfigShow: false,
      filter: [],
      modalConsolidated: false,
      contentWarehouseModal: { description: '' },
      contentUbicationModal: { name: '', id: '' },
      consolidatedReport: { results: [] },
      loadingconsolidated: false,
      modalNovelty: false,
      loadingNovelty: false,
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
    }),
  },
  methods: {
    ...warehouseMethods,
    ...reportsMethods,
    ...groupingMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchGrouping(
        this.$table_params(ctx) + '&paginate=true'
      )
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          // console.log(error)
          return []
        })
    },
    consolidatedProvider(ctx) {
      let context = this
      const promise = context.fetchConsolidatedReport(
        this.$table_params(ctx) +
          '&grouping=' +
          this.contentWarehouseModal.id
      )
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    openModalConsolidated(warehouses) {
      let context = this
      this.modalConsolidated = true
      this.contentWarehouseModal = warehouses
      // if (Boolean(ubication)) this.contentUbicationModal = ubication
      // this.loadingconsolidated = true
      // this.fetchConsolidatedReport(
      //   '?warehouse=' + warehouse.id + '&ubication=' + ubication.id
      // )
      //   .then((data) => {
      //     this.consolidatedReport = data
      //     this.loadingconsolidated = false
      //   })
      //   .catch((error) => {
      //     context.$axios_error_noty(error, context)
      //     this.loadingconsolidated = false
      //   })
    },
    hideModal() {
      this.contentWarehouseModal = { description: '' }
      this.contentUbicationModal = { name: '', id: '' }
      this.consolidatedReport = { results: [] }
    },
    openModalNovelty(warehouse, ubication) {
      let context = this
      this.modalNovelty = true
      this.contentWarehouseModal = warehouse
      if (Boolean(ubication)) this.contentUbicationModal = ubication
      this.loadingNovelty = true
      this.fetchConsolidatedReportnoset(
        '?grouping=' +
          this.contentWarehouseModal.id
      )
        .then((data) => {
          this.consolidatedReport = data
          this.loadingNovelty = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          this.consolidatedReport = []
          this.loadingNovelty = false
        })
      // this.fetchConsolidatedReport(
      //   '?warehouse=' + warehouse.id + '&ubication=' + ubication.id
      // )
      //   .then((data) => {
      //     this.consolidatedReport = data
      //     this.loadingNovelty = false
      //   })
      //   .catch((error) => {
      //     context.$axios_error_noty(error, context)
      //     this.loadingNovelty = false
      //   })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <BaseDatatable
        ref="table"
        id="table1"
        :drfprovider="myProvider"
        :tableheaders="tableHeaders"
      >
        <template v-slot:cell(warehouses)="row">
          <p
            class="p-0 m-0"
            v-for="(w, index) in row.item.warehouses"
            :key="index"
          >
            {{ w.description }}
          </p>
        </template>
        <template #cell(actions)="row">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none text-info"
            no-caret
            right
          >
            <template #button-content>
              <i class="fas fa-cog fa-lg text-info"></i>
              <span class="d-none d-md-inline"> Opciones</span>
            </template>
            <b-dropdown-item-button @click="openModalConsolidated(row.item)">
              <i class="fas fa-chart-line mr-1"></i> Consolidados
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="openModalNovelty(row.item, null)">
              <i class="far fa-chart-bar mr-1"></i> Novedades
            </b-dropdown-item-button>
          </b-dropdown>
        </template>
      </BaseDatatable>
      <b-modal
        v-model="modalConsolidated"
        size="xl"
        @hide="hideModal()"
        title="Consolidados"
      >
        <b-spinner v-if="loadingconsolidated" label="Spinning"></b-spinner>
        <div v-else>
          <p
            class="p-0 m-0"
            v-for="(w, index) in contentWarehouseModal.warehouses"
            :key="index"
          >
            {{ w.description }}
          </p>
          <BaseDatatable
            ref="tableConsolidated"
            id="tableconsolidatedReport"
            :drfprovider="consolidatedProvider"
            :tableheaders="tableHeadersConsolidated"
          >
          </BaseDatatable>
        </div>
      </b-modal>
      <b-modal
        v-model="modalNovelty"
        size="xl"
        @hide="hideModal()"
        title="Novedades"
      >
        <b-spinner v-if="loadingNovelty" label="Spinning"></b-spinner>
        <div v-else>
          <p class="lead">{{ contentWarehouseModal.description }}</p>
          <p class="lead">{{ contentUbicationModal.name }}</p>
          <BaseDatatable
            ref="tableNovelty"
            id="tableNoveltyReport"
            :drfprovider="consolidatedProvider"
            :tableheaders="tableHeadersNovelty"
          >
            <template #cell(novelty)="row">
              <b-badge
                v-if="row.item.consolidated - row.item.quantity > 0"
                variant="secondary"
                >{{ row.item.quantity - row.item.consolidated }}</b-badge
              >
              <b-badge v-else variant="primary"
                >+{{ row.item.quantity - row.item.consolidated }}</b-badge
              >
              Productos
            </template>
          </BaseDatatable>
          <!-- {{consolidatedReport}} -->
          <!-- <br />
          <p class="lead">Productos no cargados</p>
          <b-table
            :items="consolidatedReport.results"
            :fields="tableHeadersNovelty"
            stacked="md"
            small
          >
            <template #cell(novelty)="row">
            <template #cell(novelty)>
              <b-badge variant="secondary">
                No registra carga
              </b-badge>
            </template>
          </b-table> -->
        </div>
      </b-modal>
    </b-card>
  </Layout>
</template>
<style lang="scss">
#table1 {
  .text-center {
    text-align: center;
  }
  @media screen and (max-width: 765px) {
    .w-20 {
      width: 20px !important;
    }
    .w-50 {
      width: 50px !important;
    }
    .w-170 {
      width: 170px !important;
    }
  }
  @media screen and (min-width: 766px) {
    .w-20 {
      width: 120px !important;
    }
    .w-50 {
      width: 150px !important;
    }
    .w-170 {
      width: 230px !important;
    }
  }
  .b-table-details {
    background-color: #e2e6e9;
    padding-left: 5px;
    padding-top: 5px;
    thead {
      display: none;
    }
    table td {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>
